import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromMaster from './+state/master.reducer';
import { MasterEffects } from './+state/master.effects';
import { MasterFacade } from './+state/master.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromMaster.MASTER_FEATURE_KEY, fromMaster.reducer),
    EffectsModule.forFeature([MasterEffects]),
  ],
  providers: [MasterFacade],
})
export class MasterDataAccessModule {}
